import PropTypes from 'prop-types'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react'
import React from 'react'
import Table from '../../../components/Table/Table'
const columns = [
  {
    Header: 'RUT',
    accessor: 'sRut',
    type: 'dni',
  },
  {
    Header: 'Nombre',
    accessor: 'sNombreCompleto',
  },
  {
    Header: 'Estado',
    accessor: 'sEstado',
    type: 'status',
  },
  {
    Header: 'Centro de costo',
    accessor: 'sCentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'sSucursal',
  },
  {
    Header: 'Grupos',
    accessor: 'sGrupo',
  },
]
export default function ValidationModal({ isOpen, onClose, data }) {
  return (
    <Modal size={'6xl'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody mt={'40px'}>
          <Table columns={columns} data={data} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

ValidationModal.propTypes = {
  data: PropTypes.array,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
